(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $9b08d7740cc9500e$exports = {};
!function(e, t) {
    if ("function" == typeof define && define.amd) define([
        "exports"
    ], t);
    else {
        var o;
        t($9b08d7740cc9500e$exports);
    }
}($9b08d7740cc9500e$exports, function(exports1) {
    "use strict";
    function i(e) {
        if (Array.isArray(e)) {
            for(var t = 0, o = Array(e.length); t < e.length; t++)o[t] = e[t];
            return o;
        }
        return Array.from(e);
    }
    Object.defineProperty(exports1, "__esModule", {
        value: !0
    });
    var l = !1;
    if ("undefined" != typeof window) {
        var e = {
            get passive () {
                l = !0;
            }
        };
        window.addEventListener("testPassive", null, e), window.removeEventListener("testPassive", null, e);
    }
    function d(t) {
        return u.some(function(e) {
            return !(!e.options.allowTouchMove || !e.options.allowTouchMove(t));
        });
    }
    function c(e) {
        var t = e || window.event;
        return !!d(t.target) || 1 < t.touches.length || (t.preventDefault && t.preventDefault(), !1);
    }
    function o() {
        setTimeout(function() {
            void 0 !== m && (document.body.style.paddingRight = m, m = void 0), void 0 !== f && (document.body.style.overflow = f, f = void 0);
        });
    }
    var a = "undefined" != typeof window && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || "MacIntel" === window.navigator.platform && 1 < window.navigator.maxTouchPoints), u = [], s = !1, v = -1, f = void 0, m = void 0;
    exports1.disableBodyScroll = function(r, e) {
        if (a) {
            if (!r) return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
            if (r && !u.some(function(e) {
                return e.targetElement === r;
            })) {
                var t = {
                    targetElement: r,
                    options: e || {}
                };
                u = [].concat(i(u), [
                    t
                ]), r.ontouchstart = function(e) {
                    1 === e.targetTouches.length && (v = e.targetTouches[0].clientY);
                }, r.ontouchmove = function(e) {
                    var t, o, n, i;
                    1 === e.targetTouches.length && (o = r, i = (t = e).targetTouches[0].clientY - v, d(t.target) || (o && 0 === o.scrollTop && 0 < i || (n = o) && n.scrollHeight - n.scrollTop <= n.clientHeight && i < 0 ? c(t) : t.stopPropagation()));
                }, s || (document.addEventListener("touchmove", c, l ? {
                    passive: !1
                } : void 0), s = !0);
            }
        } else {
            n = e, setTimeout(function() {
                if (void 0 === m) {
                    var e = !!n && !0 === n.reserveScrollBarGap, t = window.innerWidth - document.documentElement.clientWidth;
                    e && 0 < t && (m = document.body.style.paddingRight, document.body.style.paddingRight = t + "px");
                }
                void 0 === f && (f = document.body.style.overflow, document.body.style.overflow = "hidden");
            });
            var o = {
                targetElement: r,
                options: e || {}
            };
            u = [].concat(i(u), [
                o
            ]);
        }
        var n;
    }, exports1.clearAllBodyScrollLocks = function() {
        a ? (u.forEach(function(e) {
            e.targetElement.ontouchstart = null, e.targetElement.ontouchmove = null;
        }), s && (document.removeEventListener("touchmove", c, l ? {
            passive: !1
        } : void 0), s = !1), u = [], v = -1) : (o(), u = []);
    }, exports1.enableBodyScroll = function(t) {
        if (a) {
            if (!t) return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
            t.ontouchstart = null, t.ontouchmove = null, u = u.filter(function(e) {
                return e.targetElement !== t;
            }), s && 0 === u.length && (document.removeEventListener("touchmove", c, l ? {
                passive: !1
            } : void 0), s = !1);
        } else (u = u.filter(function(e) {
            return e.targetElement !== t;
        })).length || o();
    };
});


var $e673cfb7e096dac0$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $e673cfb7e096dac0$var$R = typeof Reflect === "object" ? Reflect : null;
var $e673cfb7e096dac0$var$ReflectApply = $e673cfb7e096dac0$var$R && typeof $e673cfb7e096dac0$var$R.apply === "function" ? $e673cfb7e096dac0$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $e673cfb7e096dac0$var$ReflectOwnKeys;
if ($e673cfb7e096dac0$var$R && typeof $e673cfb7e096dac0$var$R.ownKeys === "function") $e673cfb7e096dac0$var$ReflectOwnKeys = $e673cfb7e096dac0$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $e673cfb7e096dac0$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $e673cfb7e096dac0$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $e673cfb7e096dac0$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $e673cfb7e096dac0$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $e673cfb7e096dac0$var$EventEmitter() {
    $e673cfb7e096dac0$var$EventEmitter.init.call(this);
}
$e673cfb7e096dac0$exports = $e673cfb7e096dac0$var$EventEmitter;
$e673cfb7e096dac0$exports.once = $e673cfb7e096dac0$var$once;
// Backwards-compat with node 0.10.x
$e673cfb7e096dac0$var$EventEmitter.EventEmitter = $e673cfb7e096dac0$var$EventEmitter;
$e673cfb7e096dac0$var$EventEmitter.prototype._events = undefined;
$e673cfb7e096dac0$var$EventEmitter.prototype._eventsCount = 0;
$e673cfb7e096dac0$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $e673cfb7e096dac0$var$defaultMaxListeners = 10;
function $e673cfb7e096dac0$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($e673cfb7e096dac0$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $e673cfb7e096dac0$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $e673cfb7e096dac0$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $e673cfb7e096dac0$var$defaultMaxListeners = arg;
    }
});
$e673cfb7e096dac0$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$e673cfb7e096dac0$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $e673cfb7e096dac0$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $e673cfb7e096dac0$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $e673cfb7e096dac0$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$e673cfb7e096dac0$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $e673cfb7e096dac0$var$_getMaxListeners(this);
};
$e673cfb7e096dac0$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $e673cfb7e096dac0$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $e673cfb7e096dac0$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$e673cfb7e096dac0$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $e673cfb7e096dac0$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $e673cfb7e096dac0$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $e673cfb7e096dac0$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $e673cfb7e096dac0$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$e673cfb7e096dac0$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $e673cfb7e096dac0$var$_addListener(this, type, listener, false);
};
$e673cfb7e096dac0$var$EventEmitter.prototype.on = $e673cfb7e096dac0$var$EventEmitter.prototype.addListener;
$e673cfb7e096dac0$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $e673cfb7e096dac0$var$_addListener(this, type, listener, true);
};
function $e673cfb7e096dac0$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $e673cfb7e096dac0$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $e673cfb7e096dac0$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$e673cfb7e096dac0$var$EventEmitter.prototype.once = function once(type, listener) {
    $e673cfb7e096dac0$var$checkListener(listener);
    this.on(type, $e673cfb7e096dac0$var$_onceWrap(this, type, listener));
    return this;
};
$e673cfb7e096dac0$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $e673cfb7e096dac0$var$checkListener(listener);
    this.prependListener(type, $e673cfb7e096dac0$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$e673cfb7e096dac0$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $e673cfb7e096dac0$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $e673cfb7e096dac0$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$e673cfb7e096dac0$var$EventEmitter.prototype.off = $e673cfb7e096dac0$var$EventEmitter.prototype.removeListener;
$e673cfb7e096dac0$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $e673cfb7e096dac0$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $e673cfb7e096dac0$var$unwrapListeners(evlistener) : $e673cfb7e096dac0$var$arrayClone(evlistener, evlistener.length);
}
$e673cfb7e096dac0$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $e673cfb7e096dac0$var$_listeners(this, type, true);
};
$e673cfb7e096dac0$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $e673cfb7e096dac0$var$_listeners(this, type, false);
};
$e673cfb7e096dac0$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $e673cfb7e096dac0$var$listenerCount.call(emitter, type);
};
$e673cfb7e096dac0$var$EventEmitter.prototype.listenerCount = $e673cfb7e096dac0$var$listenerCount;
function $e673cfb7e096dac0$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$e673cfb7e096dac0$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $e673cfb7e096dac0$var$ReflectOwnKeys(this._events) : [];
};
function $e673cfb7e096dac0$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $e673cfb7e096dac0$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $e673cfb7e096dac0$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $e673cfb7e096dac0$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $e673cfb7e096dac0$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $e673cfb7e096dac0$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $e673cfb7e096dac0$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $e673cfb7e096dac0$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $e673cfb7e096dac0$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}


// If you want to expose a new function from `index.js`, add it here and it'll work from production
// automagically. Keep in mind that return values are discarded.
const $6945f2598de502fd$var$functions = [
    "open",
    "getHeight"
];
// Origin will be replaced as close as possible to each environment (usually during deploy, see .gitlab-ci.yaml)
// Examples dev-mode: https://widget.local.trialbee.xyz, prod-mode: https://widget.trialbee.com
let $6945f2598de502fd$var$origin = "____ORIGIN____";
const $6945f2598de502fd$var$FRAME_SOURCE = [
    $6945f2598de502fd$var$origin,
    "selfAssessment.html"
].join("/");
// HACK: Used to detect iOS in order to handle scroll locking differently
const $6945f2598de502fd$var$isIosDevice = typeof window !== "undefined" && window.navigator && window.navigator.platform && /iP(ad|hone|od)/.test(window.navigator.platform);
function $6945f2598de502fd$var$appendIframeStyles(document1) {
    const css = `
iframe.tb-self-assessment {
  border: none;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
  z-index: 999999999;
}

body.self-assessment-open iframe.tb-self-assessment {
  display: block;
}

@media print {
  body.self-assessment-open > *:not(.tb-self-assessment) {
    display: none;
  }
  body.self-assessment-open iframe.tb-self-assessment {
    display: block !important;
    position: absolute;
  }
}
`;
    const style = document1.createElement("style");
    style.type = "text/css";
    style.appendChild(document1.createTextNode(css));
    document1.head.appendChild(style);
}
class $6945f2598de502fd$var$TrialbeeSelfAssessment extends (0, (/*@__PURE__*/$parcel$interopDefault($e673cfb7e096dac0$exports))) {
    _proxy(f, options) {
        return new Promise((resolve, reject)=>{
            let callbackId = 0;
            while(callbackId in this._callbacks)callbackId += 1;
            this._callbacks[callbackId] = [
                resolve,
                reject
            ];
            window.frames[this._frameName].postMessage(JSON.stringify({
                f: f,
                callbackId: callbackId,
                options: options
            }), $6945f2598de502fd$var$origin);
        });
    }
    _onshow() {
        this._previousFocusElement = document.activeElement;
        document.body.classList.add("self-assessment-open");
        this._frame.removeAttribute("aria-hidden");
        // this._frame.focus();
        if (!$6945f2598de502fd$var$isIosDevice) (0, $9b08d7740cc9500e$exports.disableBodyScroll)(this._frame);
        else {
            document.body.style.position = "fixed";
            document.body.style.height = "100%";
            document.documentElement.style.height = "100%";
            document.documentElement.style.position = "fixed";
            document.documentElement.style.overflow = "hidden";
        }
    }
    _onhide() {
        document.body.classList.remove("self-assessment-open");
        this._frame.setAttribute("aria-hidden", "true");
        if (!$6945f2598de502fd$var$isIosDevice) (0, $9b08d7740cc9500e$exports.clearAllBodyScrollLocks)();
        else {
            document.body.style.position = "";
            document.body.style.height = "";
            document.documentElement.style.height = "";
            document.documentElement.style.position = "";
            document.documentElement.style.overflow = "";
        }
        if (this._previousFocusElement) this._previousFocusElement.focus();
    }
    _onaction(options) {
        this.emit("action", options.action, options.values);
    }
    constructor(){
        super();
        $6945f2598de502fd$var$appendIframeStyles(document);
        // This is programmer speak for "please don't touch our things, thank you ❤️"
        this._frameName = `tb-self-assessment-${Math.floor(Math.random() * 1000)}`;
        this._frame = document.createElement("iframe");
        this._frame.name = this._frameName;
        this._frame.src = $6945f2598de502fd$var$FRAME_SOURCE;
        this._frame.allow = "geolocation";
        this._frame.classList.add("tb-self-assessment");
        this._frame.setAttribute("aria-hidden", "true");
        this._frame.setAttribute("title", "Sign up for study");
        this._frame.addEventListener("load", ()=>{
            $6945f2598de502fd$var$functions.forEach((f)=>{
                this[f] = this._proxy.bind(this, f);
            });
            this.emit("load", this._frameName);
        });
        document.body.appendChild(this._frame);
        window.addEventListener("message", (e)=>{
            if (e.source !== window.frames[this._frameName] || e.origin !== $6945f2598de502fd$var$origin || typeof e.data !== "string") return;
            const { type: type, options: options } = JSON.parse(e.data);
            if (type === "open") {
                this._onshow();
                this.emit("open", this._frameName);
            } else if (type === "close") {
                this._onhide();
                this.emit("close", this._frameName);
                if (options && options.redirectUrl) {
                    const link = options.redirectUrl;
                    const url = link.indexOf("://") > 0 ? link : `https://${link}`;
                    window.location.href = url;
                }
            } else if (type === "done") {
                const [resolve] = this._callbacks[options.callbackId];
                resolve(options.returnValue);
                delete this._callbacks[options.callbackId];
                this.emit("done", this._frameName);
            } else if (type === "setHeight") this._frame.style.height = `${options.scrollHeight}px`;
            else if (type === "error") {
                const [_, reject] = this._callbacks[options.callbackId];
                reject(options.message);
                delete this._callbacks[options.callbackId];
                if (options.fatal) this._onhide();
                this.emit("error", options.message, options.fatal);
            } else if (type === "action") this._onaction(options);
        });
        window.addEventListener("beforeprint", ()=>{
            this._proxy("getHeight");
        });
        window.addEventListener("afterprint", ()=>{
            this._frame.style.height = "";
        });
        this._callbacks = {};
    }
}
window.TrialbeeSelfAssessment = $6945f2598de502fd$var$TrialbeeSelfAssessment;
// Deprecated: use the above instead.
window.TrialbeeRecruitmentWidget = $6945f2598de502fd$var$TrialbeeSelfAssessment;

})();
//# sourceMappingURL=prescreener.js.map
